import axiosInstance from "./api";

let cachedCoreSkills = null;
let lastFetchTime = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

export const getCoreSkills = async () => {
  const currentTime = Date.now();

  // If cache is valid, return cached data
  if (cachedCoreSkills && currentTime - lastFetchTime < CACHE_DURATION) {
    return cachedCoreSkills;
  }

  // If cache is invalid or doesn't exist, fetch new data
  try {
    const { data } = await axiosInstance.get("/api/skills");
    const coreSkills = data.data.map((result) => ({
      id: `core-${result.name}`,
      key: result.name,
      description: result.description,
      preProcessing: result.stages.indexOf("pre-processing") !== -1,
      postProcessing: result.stages.indexOf("post-processing") !== -1,
      tags: result.tags,
      example: result.example,
      core: true,
      custom: false,
    }));

    // Update cache and last fetch time
    cachedCoreSkills = coreSkills;
    lastFetchTime = currentTime;

    return coreSkills;
  } catch (error) {
    console.error("Error fetching core skills:", error);
    throw error;
  }
};

// Optional: Function to manually clear the cache if needed
export const clearCoreSkillsCache = () => {
  cachedCoreSkills = null;
  lastFetchTime = 0;
};
